export default class FilterController {
  constructor(config = {}) {
    this.filterNames = config.filterNames || ['age', 'thinning_area', 'treatment', 'cancer_treatment'];
    this.cardSelector = config.cardSelector || 'li.js-remedy-card';
    this.checkboxSelector = config.checkboxSelector || '.js-remedy-checklist input[type="checkbox"]';

    // 安全確認してから初期化
    if (document.querySelector(this.cardSelector) || document.querySelector(this.checkboxSelector)) {
      this.init();
    }
  }

  init() {
    if (this.applyUrlParamsToCheckboxes()) {
      this.filterCards();
    }
    this.bindEvents();
  }

  applyUrlParamsToCheckboxes() {
    const urlParams = new URLSearchParams(window.location.search);
    this.filterNames.forEach(name => {
      const param = urlParams.get(name);
      if (param) {
        param.split(',').forEach(val => {
          const checkbox = document.querySelector(`input[name="${name}"][value="${val}"]`);
          if (checkbox) checkbox.checked = true;
        });
      }
    });
    return true;
  }

  getCheckedValues(name) {
    return Array.from(document.querySelectorAll(`input[name="${name}"]:checked`)).map(cb => cb.value);
  }

  filterCards() {
    const selected = {};
    this.filterNames.forEach(name => {
      selected[name] = this.getCheckedValues(name);
    });

    document.querySelectorAll(this.cardSelector).forEach(card => {
      const matches = this.filterNames.every(name => {
        const dataAttr = name.replace(/_/g, '-');
        const cardValue = card.dataset[dataAttr] || '';
        return selected[name].length === 0 || selected[name].includes(cardValue);
      });
      card.style.display = matches ? '' : 'none';
    });
  }

  updateURL() {
    const urlParams = new URLSearchParams();
    this.filterNames.forEach(name => {
      const selected = this.getCheckedValues(name);
      if (selected.length > 0) {
        urlParams.append(name, selected.join(','));
      }
    });
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    window.history.pushState(null, '', newUrl);
  }

  bindEvents() {
    document.querySelectorAll(this.checkboxSelector).forEach(cb => {
      cb.addEventListener('change', () => {
        this.filterCards();
        this.updateURL();
      });
    });
  }
}
